import {
  ReachedLimitPeriods,
  ReachedLimitTypes,
} from './LimitReachedBottomSheet.types';

export const getLimitExceededMessage = (
  period: ReachedLimitPeriods,
  type: ReachedLimitTypes,
) => {
  const limitsMap: Record<
    ReachedLimitTypes,
    Record<ReachedLimitPeriods, keyof RegisteredLocales['responsibleGaming']>
  > = {
    [ReachedLimitTypes.Loss]: {
      [ReachedLimitPeriods.Daily]: 'reachedDailyLossLimit',
      [ReachedLimitPeriods.Weekly]: 'reachedWeeklyLossLimit',
      [ReachedLimitPeriods.Monthly]: 'reachedMonthlyLossLimit',
    },
    [ReachedLimitTypes.Time]: {
      [ReachedLimitPeriods.Daily]: 'reachedDailyTimeLimit',
      [ReachedLimitPeriods.Weekly]: 'reachedWeeklyTimeLimit',
      [ReachedLimitPeriods.Monthly]: 'reachedMonthlyTimeLimit',
    },
  };

  return limitsMap[type]?.[period];
};
